import React, { useEffect, useState, useRef } from "react";
import AddChannelPopUp from "../../component/AddChannelPopUp/AddChannelPopUp";
import { getLiveChannelData, liveChannelDelete } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import ListView from "../../component/ListView/ListView";
import {
  buildContentCard,
  contentStats,
} from "../../component/ListView/contentCard";
import { channelListData } from "../../component/AddNewChannels/Data";
import { useLocation, useNavigate } from "react-router-dom";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import { useSearch } from "../../context/SearchContext";
import FloatingButton from "../../component/FloatingButton/FloatingButton";
import { useRbac } from "../../rbac/RbacContext";

const LiveTVChannels = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [dropDownData, setDropDownData] = useState();
  const [channel, setChannel] = useState()
  const [totalCount, setTotalCount] = useState(0);
  const [deletingId, setDeletingId] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedCreator, setSelectedCreator] = useState("");
  const [selectedRating, setSelectedRating] = useState("");
  const [selectedGenre, setSelectedGenre] = useState();
    const [loading, setLoading] = useState(false);

  const role = localStorage.getItem("role");
  const { can } = useRbac();
  // Server also enforces this via requirePermission on POST /live-channel/create.
  const canCreateLiveTV = can("livetv", "create");
  const navigate = useNavigate();
  const location = useLocation();
  const {searchQuery}=useSearch()
  const prevSearchQuery = useRef(searchQuery);
  const { liveTV } = location.state || {};
  const handleAddChannel = () => {
    // setShowPopup(true);
     navigate(
       `/video/`,
       {
         state: {
           name: "Live Channels",
           live_type: "Channel",
         },
       }
     );
  };
   const handleAddEvent = () => {
     // setShowPopup(true);
     navigate(`/video/`, {
       state: {
         name: "Live Events",
       },
     });
   };

  const getShortClipsList = async (page, limit) => {
    if (searchQuery) return;
        setLoading(true);

    try {
      const response = await channelListData(
        selectedDate,
        selectedCreator,
        selectedRating,
        selectedGenre,
        page,
        limit
      );
      setChannel(response.data);
      setTotalCount(response.totalCount);
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleEdit = (id, metadata_id, item) => {
    // Use metadata_id in URL if available, otherwise use original id
    const urlId = metadata_id || id;
    const hasMetadataId = Boolean(metadata_id);
    const url = hasMetadataId ? `/video/${urlId}` : `/video/${urlId}?meta=false`;
    
    navigate(url, {
      state: {
        movieId: id, // Always pass original id for API calls
        metadata_id: metadata_id || "", // Include metadata_id in body parameters
        name: "Live Channels",

        live_type: item.live_type,
      },
    });
  
  };
  const handleDelete = async (id, metadata_id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmed) return;
    // Use metadata_id if available, otherwise use id (same as edit)
    const deleteId = metadata_id || id;
    setDeletingId(deleteId);
    try {
      const response = await liveChannelDelete(deleteId);
      setChannel((prev) => prev.filter((item) => (item.metadata_id || item.id) !== deleteId));
      // Keep the Total tile in step without a refetch.
      setTotalCount((c) => Math.max(0, (Number(c) || 0) - 1));
      showToast(response.data.message, "success");
    } catch (error) {
      showToast(error.response.data.message, "error");
    } finally {
      setDeletingId(null);
    }
  };

  const cardFor = buildContentCard(handleEdit, handleDelete, deletingId);
  const stats = contentStats(channel || [], totalCount);
  const handleFilterChange = async (type, value) => {
    if (type === "genre") setSelectedGenre(value);
    if (type === "date") setSelectedDate(value);
    if (type === "creator") setSelectedCreator(value);
    if (type === "rating") setSelectedRating(value);
    setLoading(true);

    const updatedGenre = type === "genre" ? value : selectedGenre;
    const updatedDate = type === "date" ? value : selectedDate;
    const updatedCreator = type === "creator" ? value : selectedCreator;
    const updatedRating = type === "rating" ? value : selectedRating;
    try {
      const response = await getLiveChannelData(
        {},
        updatedDate,
        updatedCreator,
        updatedRating,
        updatedGenre,
        undefined,
        undefined,
        searchQuery
      );

      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      const formattedData = data.map((item) => ({
        id: item.id,
        metadata_id: item.metadata_id,
        name: trimStr(item.name),
        media: item.portrait,
        status: item.status,
        qc_status: item.qc_status,
        rating: item.rating,
        access: item.access,
        live_type: item.live_type,
        buttonText: "Edit",
        buttonText2: "Remove",
      }));

      setChannel(formattedData);

      setTotalCount(response?.data?.total);
      showToast();
    } catch (error) {
      showToast("Failed to apply filter", "error");
    } finally {
      setLoading(false);
    }
  };


useEffect(() => {
  if (prevSearchQuery.current === searchQuery) {
    return;
  }
  prevSearchQuery.current = searchQuery;

  const timer = setTimeout(() => {
    if (searchQuery === "" || searchQuery ) {
      handleFilterChange("search", "");
    }
  }, 500);

  return () => clearTimeout(timer);
}, [searchQuery]);

  return (
    <div>
      {showPopup || liveTV ? (
        <AddChannelPopUp onClose={closePopup} />
      ) : (
        <div>
          <ListView
            heading="Live TV"
            data={channel}
            getCard={cardFor}
            stats={stats}
            totalCount={totalCount}
            button={true}
            handleFilterChange={handleFilterChange}
            selectedDate={selectedDate}
            selectedRating={selectedRating}
            onPageChange={getShortClipsList}
            selectedGenre={selectedGenre}
            tableLoading={loading}
            addLabel="New Event"
            onAdd={canCreateLiveTV ? handleAddEvent : undefined}
          />
          <FloatingButton />
        </div>
      )}
    </div>
  );
};

export default LiveTVChannels;